import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import * as reducers from '../../reducers';
import { IApplicationState } from '../../types/redux';
import { pageSlice, userSlice, realtorsSlice, formSubmitDataSlice } from '../../slices';
import { createLocationApi } from '../../api/locationApi';
import { createFormDataApi } from '../../api/formDataApi';
import { IApplicationContext } from '../../types/ICustomContextParams';
import { createSpecialistsApi } from '../../api/specialistsApi';
import { createRealtorInfoApi } from '../../api/realtorInfoApi';

export function createReduxStore(
  preloadedState: Partial<IApplicationState>,
  debugEnabled: boolean,
  context: IApplicationContext,
) {
  const locationApi = createLocationApi(context);
  const forDataApi = createFormDataApi(context);
  const specialistsApi = createSpecialistsApi(context);
  const realtorInfoApi = createRealtorInfoApi(context);

  const rootReducer = combineReducers({
    ...reducers,
    [locationApi.reducerPath]: locationApi.reducer,
    [forDataApi.reducerPath]: forDataApi.reducer,
    [specialistsApi.reducerPath]: specialistsApi.reducer,
    [realtorInfoApi.reducerPath]: realtorInfoApi.reducer,
    [pageSlice.name]: pageSlice.reducer,
    [userSlice.name]: userSlice.reducer,
    [realtorsSlice.name]: realtorsSlice.reducer,
    [formSubmitDataSlice.name]: formSubmitDataSlice.reducer,
  });

  const store = configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: { extraArgument: context },
      }).concat(locationApi.middleware, forDataApi.middleware, specialistsApi.middleware, realtorInfoApi.middleware),
    devTools: debugEnabled,
  });

  setupListeners(store.dispatch);

  return store;
}
